package nl.volleyplanner.api.entities

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.sports.Club


@Serializable
data class Organisation(
    val identifier: String,
    val name: String,
    val slug: String,
    val linkedClub: Club?
)

@Serializable
data class OrganisationSeason(
    val name: String,
    val active: Boolean
)